// メッセージMap
export const MessageMap = {
    "start_time": "開始時間",
    "end_time": "終了時間",
    "internship_type_id": "実習カテゴリ",
};